/* eslint-disable */
import * as registry from '../registry.js'
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ number: NonNullable<unknown> }} Daily_Picks_Description_MinInputs */

const en_daily_picks_description_min = /** @type {(inputs: Daily_Picks_Description_MinInputs) => LocalizedString} */ (i) => {const numberPlural = registry.plural("en", i?.number, {});
	if (numberPlural == "one") return /** @type {LocalizedString} */ (`Refresh in ${i?.number} min.`);
	if (numberPlural == "other") return /** @type {LocalizedString} */ (`Refresh in ${i?.number} mins.`);
	return /** @type {LocalizedString} */ (`Refresh in ${i?.number} mins.`)
	
};

const ar_daily_picks_description_min = /** @type {(inputs: Daily_Picks_Description_MinInputs) => LocalizedString} */ (i) => {const numberPlural = registry.plural("ar", i?.number, {});
	if (numberPlural == "zero") return /** @type {LocalizedString} */ (`التحديث خلال ${i?.number} دقيقة.`);
	if (numberPlural == "one") return /** @type {LocalizedString} */ (`التحديث خلال ${i?.number} دقيقة.`);
	if (numberPlural == "two") return /** @type {LocalizedString} */ (`التحديث خلال ${i?.number} دقيقتين.`);
	if (numberPlural == "few") return /** @type {LocalizedString} */ (`التحديث خلال ${i?.number} دقائق.`);
	if (numberPlural == "many") return /** @type {LocalizedString} */ (`التحديث خلال ${i?.number} دقيقةً.`);
	if (numberPlural == "other") return /** @type {LocalizedString} */ (`التحديث خلال ${i?.number} دقيقة.`);
	return /** @type {LocalizedString} */ (`التحديث خلال ${i?.number} دقيقة.`)
	
};

const de_daily_picks_description_min = /** @type {(inputs: Daily_Picks_Description_MinInputs) => LocalizedString} */ (i) => {const numberPlural = registry.plural("de", i?.number, {});
	if (numberPlural == "one") return /** @type {LocalizedString} */ (`Aktualisierung in ${i?.number} Min.`);
	if (numberPlural == "other") return /** @type {LocalizedString} */ (`Aktualisierung in ${i?.number} Min.`);
	return /** @type {LocalizedString} */ (`Aktualisierung in ${i?.number} Min.`)
	
};

const es_daily_picks_description_min = /** @type {(inputs: Daily_Picks_Description_MinInputs) => LocalizedString} */ (i) => {const numberPlural = registry.plural("es", i?.number, {});
	if (numberPlural == "one") return /** @type {LocalizedString} */ (`Se actualiza en ${i?.number} min.`);
	if (numberPlural == "other") return /** @type {LocalizedString} */ (`Se actualiza en ${i?.number} min.`);
	return /** @type {LocalizedString} */ (`Se actualiza en ${i?.number} min.`)
	
};

const fr_daily_picks_description_min = /** @type {(inputs: Daily_Picks_Description_MinInputs) => LocalizedString} */ (i) => {const numberPlural = registry.plural("fr", i?.number, {});
	if (numberPlural == "one") return /** @type {LocalizedString} */ (`Actualisation dans ${i?.number} min.`);
	if (numberPlural == "other") return /** @type {LocalizedString} */ (`Actualisation dans ${i?.number} min.`);
	return /** @type {LocalizedString} */ (`Actualisation dans ${i?.number} min.`)
	
};

const it_daily_picks_description_min = /** @type {(inputs: Daily_Picks_Description_MinInputs) => LocalizedString} */ (i) => {const numberPlural = registry.plural("it", i?.number, {});
	if (numberPlural == "one") return /** @type {LocalizedString} */ (`Aggiornamento tra ${i?.number} min.`);
	if (numberPlural == "other") return /** @type {LocalizedString} */ (`Aggiornamento tra ${i?.number} min.`);
	return /** @type {LocalizedString} */ (`Aggiornamento tra ${i?.number} min.`)
	
};

const ja_daily_picks_description_min = /** @type {(inputs: Daily_Picks_Description_MinInputs) => LocalizedString} */ (i) => {const numberPlural = registry.plural("ja", i?.number, {});
	if (numberPlural == "other") return /** @type {LocalizedString} */ (`${i?.number}分後に更新`);
	return /** @type {LocalizedString} */ (`${i?.number}分後に更新`)
	
};

const ko_daily_picks_description_min = /** @type {(inputs: Daily_Picks_Description_MinInputs) => LocalizedString} */ (i) => {const numberPlural = registry.plural("ko", i?.number, {});
	if (numberPlural == "other") return /** @type {LocalizedString} */ (`${i?.number}분 후 새로고침`);
	return /** @type {LocalizedString} */ (`${i?.number}분 후 새로고침`)
	
};

const pt_br_daily_picks_description_min = /** @type {(inputs: Daily_Picks_Description_MinInputs) => LocalizedString} */ (i) => {const numberPlural = registry.plural("pt_br", i?.number, {});
	if (numberPlural == "one") return /** @type {LocalizedString} */ (`Atualiza em ${i?.number} min.`);
	if (numberPlural == "other") return /** @type {LocalizedString} */ (`Atualiza em ${i?.number} min.`);
	return /** @type {LocalizedString} */ (`Atualiza em ${i?.number} min.`)
	
};

const ru_daily_picks_description_min = /** @type {(inputs: Daily_Picks_Description_MinInputs) => LocalizedString} */ (i) => {const numberPlural = registry.plural("ru", i?.number, {});
	if (numberPlural == "one") return /** @type {LocalizedString} */ (`Обновление через ${i?.number} мин.`);
	if (numberPlural == "few") return /** @type {LocalizedString} */ (`Обновление через ${i?.number} мин.`);
	if (numberPlural == "many") return /** @type {LocalizedString} */ (`Обновление через ${i?.number} мин.`);
	if (numberPlural == "other") return /** @type {LocalizedString} */ (`Обновление через ${i?.number} мин.`);
	return /** @type {LocalizedString} */ (`Обновление через ${i?.number} мин.`)
	
};

const th_daily_picks_description_min = /** @type {(inputs: Daily_Picks_Description_MinInputs) => LocalizedString} */ (i) => {const numberPlural = registry.plural("th", i?.number, {});
	if (numberPlural == "other") return /** @type {LocalizedString} */ (`รีเฟรชในอีก ${i?.number} นาที`);
	return /** @type {LocalizedString} */ (`รีเฟรชในอีก ${i?.number} นาที`)
	
};

const tr_daily_picks_description_min = /** @type {(inputs: Daily_Picks_Description_MinInputs) => LocalizedString} */ (i) => {const numberPlural = registry.plural("tr", i?.number, {});
	if (numberPlural == "one") return /** @type {LocalizedString} */ (`${i?.number} dk. içinde yenilenir.`);
	if (numberPlural == "other") return /** @type {LocalizedString} */ (`${i?.number} dk. içinde yenilenir.`);
	return /** @type {LocalizedString} */ (`${i?.number} dk. içinde yenilenir.`)
	
};

const zh_cn_daily_picks_description_min = /** @type {(inputs: Daily_Picks_Description_MinInputs) => LocalizedString} */ (i) => {const numberPlural = registry.plural("zh_cn", i?.number, {});
	if (numberPlural == "other") return /** @type {LocalizedString} */ (`${i?.number} 分钟后刷新`);
	return /** @type {LocalizedString} */ (`${i?.number} 分钟后刷新`)
	
};

const zh_tw_daily_picks_description_min = /** @type {(inputs: Daily_Picks_Description_MinInputs) => LocalizedString} */ (i) => {const numberPlural = registry.plural("zh_tw", i?.number, {});
	if (numberPlural == "other") return /** @type {LocalizedString} */ (`${i?.number} 分鐘後刷新`);
	return /** @type {LocalizedString} */ (`${i?.number} 分鐘後刷新`)
	
};

/**
* | numberPlural | output |
* | --- | --- |
* | "one" | "Refresh in {number} min." |
* | "other" | "Refresh in {number} mins." |
* | * | "Refresh in {number} mins." |
*
* @param {Daily_Picks_Description_MinInputs} inputs
* @param {{ locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }} options
* @returns {LocalizedString}
*/
export const daily_picks_description_min = /** @type {((inputs: Daily_Picks_Description_MinInputs, options?: { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Daily_Picks_Description_MinInputs, { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_daily_picks_description_min(inputs)
	if (locale === "ar") return ar_daily_picks_description_min(inputs)
	if (locale === "de") return de_daily_picks_description_min(inputs)
	if (locale === "es") return es_daily_picks_description_min(inputs)
	if (locale === "fr") return fr_daily_picks_description_min(inputs)
	if (locale === "it") return it_daily_picks_description_min(inputs)
	if (locale === "ja") return ja_daily_picks_description_min(inputs)
	if (locale === "ko") return ko_daily_picks_description_min(inputs)
	if (locale === "pt_br") return pt_br_daily_picks_description_min(inputs)
	if (locale === "ru") return ru_daily_picks_description_min(inputs)
	if (locale === "th") return th_daily_picks_description_min(inputs)
	if (locale === "tr") return tr_daily_picks_description_min(inputs)
	if (locale === "zh_cn") return zh_cn_daily_picks_description_min(inputs)
	return zh_tw_daily_picks_description_min(inputs)
});